export default __webpack_public_path__ + "static/media/ohyd.e0151f2b.jpg";